import { getOpenId } from "@/http/salary";

export async function init(){
    const res = await getOpenId("/wxAuth/codeToOpenid",{code:GetQueryString('code')});
        if(res.msg == 'success'){
            this.$store.dispatch('SAVEUSERACTION',res.data)
            return res.data
        }
}
export function GetQueryString(name){
    var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);//search,查询？后面的参数，并匹配正则
    if(r!=null)return  unescape(r[2]); return null;
}
